import { Component, OnInit } from '@angular/core';
import {FormControl} from '@angular/forms';
import {OfflineactivationService} from "../services/offlineactivation.service";
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-offlineactivation',
  templateUrl: './offlineactivation.component.html',
  styleUrls: ['./offlineactivation.component.scss']
})
export class OfflineactivationComponent implements OnInit {
  status: 'failure' | 'loading' | 'success' | 'none' | 'instance' = 'none';
  statusmessage: any;
  challengeCode = new FormControl('');
  validation  = 'Paste challenge';
  responsecode = '';
  challenge;
  version = 2;

  constructor(private offlineActivationService: OfflineactivationService, private title: Title, private route: ActivatedRoute) {
    this.title.setTitle('Xeotek KaDeck - Offline activation');
    this.route.queryParams.subscribe(params => {

    });

  }

  ngOnInit(): void {

  }

  onChallengeEntered() {
    let code = OfflineactivationComponent.removeUnwantedCharacters(this.challengeCode.value);
    if (code.length > 50) {
      global.Buffer = global.Buffer || require('buffer').Buffer;

      // console.log("Buffer",Buffer.from(code, "base64").toString("utf8"))
      try {
        this.challenge = JSON.parse(Buffer.from(code, "base64").toString("utf8"));
        if (this.challenge.hasOwnProperty("secret") && this.challenge.hasOwnProperty("instanceid") && this.challenge.hasOwnProperty("teamid")){
          this.validation = 'true';
          return;
        }
      } catch (ignore) { }
      this.validation = 'Malformed';
    } else if (code.length === 0) {
      this.validation  = 'Paste challenge';
    } else {
      this.validation  = 'Too short';
    }
  }

  private static removeUnwantedCharacters(value: string) {
    if (!!value)
      return value.replace(/\s/g, "").trim();
    else
      return "";
  }

  activateInstance(force? : boolean) {
    this.status = "loading";

    this.offlineActivationService.activateInstance(this.challenge.teamid, this.challenge.instanceid, this.challenge.secret, force).subscribe((response:{"statusCode":any, "body":any}) => {
      if (response.statusCode === 200) {
        this.responsecode = OfflineactivationComponent.responseToBase64(response);
        this.status = "success";
        this.statusmessage = "Copy your response code";
        return;
      } else if (response.statusCode === 403) {
        if (response.body === "INSTANCE"){
          this.status = "instance";
          this.statusmessage = "";
        } else {
          this.status = "failure";
          this.statusmessage = "Challenge is not valid.";
        }
      } else {
        this.status = "failure";
        this.statusmessage = "Challenge is not valid. Code "+response.statusCode;
      }
    }, error => {
      console.log("Error", error);
      if(error.msg == undefined){
        this.status = "failure";
        this.statusmessage = "Failed: License server unreachable. The connection may be blocked by a firewall. Try it over another network if applicable.";
        return;
      }
      this.status = "failure";
      this.statusmessage = "Failed: "+error.msg;
    });
  }


  private static responseToBase64 (response:any):string {
    return Buffer.from(JSON.stringify(response), "utf-8").toString("base64");
  }

  copyToClipboard() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.responsecode;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}
